<template>
    <v-card>
        <v-card-title>{{ $t('choose_org') }}</v-card-title>
        <v-card-subtitle v-if="rolle === 'unternehmer'">{{
            $t('choose_or_create_org_force')
        }}</v-card-subtitle>
        <v-card-subtitle v-else>{{ $t('choose_or_create_org') }}</v-card-subtitle>
        <v-card-text>
            <v-checkbox
                v-if="rolle !== 'unternehmer'"
                v-model="showOrgGrid"
                :label="$t('org_person')"
            ></v-checkbox>
            <AdressenGrid
                v-if="showOrgGrid"
                :edit="false"
                :dense="false"
                :selectable="true"
                :height="300"
                :addbtn="$t('new_organisation')"
                :headerwidths="{
                    typ: '5%',
                    name: '18%',
                    vorname: '0%',
                    adresse: '25%',
                    land: '0%',
                    plz: '14%',
                    ort: '18%',
                    action: '0%',
                }"
                :selection="adresse"
                :typfilter="typFilter"
                :reload="reloadGrid"
                @selection="onSelect"
                @reload="reloadGrid = false"
                @new-address="onNewOrg"
            ></AdressenGrid>
        </v-card-text>
        <v-card-actions>
            <v-btn
                variant="flat"
                color="action white--text"
                @click="$emit('back')"
                prepend-icon="fas fa-arrow-left"
            >
                {{ $t('back') }}
            </v-btn>
            <v-btn
                :disabled="nextDisabled"
                variant="flat"
                color="action white--text"
                @click="$emit('next')"
                append-icon="fas fa-arrow-right"
            >
                {{ $t('next') }}
            </v-btn>
        </v-card-actions>
        <v-dialog v-if="showAddOrgDlg" v-model="showAddOrgDlg" max-width="1000">
            <v-card>
                <AdresseForm
                    :new-address="newOrg"
                    avoid-type-edit
                    @close="onNewOrgClose"
                    show-in-dialog
                />
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script setup lang="ts">
import AdressenGrid from '@/components/adressen-grid.vue'
import { Adresse, AdresseTyp } from '@/models/Adresse'
import AdresseForm from '@/views/auth/adressen/AdressenForm.vue'
import { computed, onMounted, ref, watch, type Ref } from 'vue'

const { rolle } = defineProps<{ rolle: string }>()

const showOrgGrid = ref(false)
const adresse: Ref<Adresse | null> = ref(null)
const newOrg: Ref<Adresse | null> = ref(null)
const typFilter = ref(AdresseTyp.ORGANISATION)
const showAddOrgDlg = ref(false)
const reloadGrid = ref(false)

const nextDisabled = computed(() => {
    if (rolle === 'unternehmer') {
        return !adresse.value
    } else {
        return showOrgGrid.value && !adresse.value
    }
})

const emit = defineEmits<{
    (e: 'next'): void
    (e: 'back'): void
    (e: 'update:modelValue', value: Adresse | null): void
}>()

watch(
    () => rolle,
    (val) => {
        showOrgGrid.value = val === 'unternehmer'
        onSelect(null)
    },
)

watch(showOrgGrid, (val) => {
    if (!val) {
        onSelect(null)
    }
})
onMounted(() => {
    showOrgGrid.value = rolle === 'unternehmer'
    onSelect(null)
})

function onSelect(value: Adresse | null) {
    adresse.value = value
    emit('update:modelValue', value)
}

async function onNewOrgClose(org: Adresse | null) {
    showAddOrgDlg.value = false
    onSelect(org)
    reloadGrid.value = true
}

function onNewOrg() {
    newOrg.value = new Adresse()
    newOrg.value.typ = AdresseTyp.ORGANISATION
    showAddOrgDlg.value = true
}
</script>
